import React from "react";
import Modal from "react-bootstrap/lib/Modal";
import Button from "react-bootstrap/lib/Button";
import {activityTypes} from "../../constants";
import {postActivityLog} from "../../api";

export class ActivityLogModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activityData: this.props.activity ? this.props.activity.data : {},
        };

        this.handleClose = this.handleClose.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleClose() {
        this.setState((state, props) => {
            return {activityData: {}}
        });
        this.props.setShowModal(false);
    }

    handleSave() {
        const {activityData} = this.state;
        const data = {
            "type": activityTypes.SAVE,
            "data": activityData
        };
        postActivityLog(data, this.props.user.api_token, this.props.onSaveCallback);
    }

    handleInputChange(event) {
        const target = event.target;
        this.setState((state, props) => {
            const activityData = {...state.activityData};
            activityData[target.name] = target.value;
            return {activityData}
        });
    }

    render() {
        let inputFields = [];

        inputFields.push(
            <React.Fragment key={1}>
                <span>Description</span>
                <input
                    name="description"
                    type="text"
                    value={this.state.activityData["description"]}
                    onChange={this.handleInputChange}
                    className="form-control"/>
            </React.Fragment>
        );

        return (
            <Modal show={this.props.show} onHide={this.handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{this.props.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {inputFields}
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="default" onClick={this.handleClose}>
                        Close
                    </Button>
                    <Button bsStyle="primary" onClick={this.handleSave}>
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    }
}
